<template>
  <div class="flex items-stretch h-full">
    <aside class="hidden md:flex w-2/4 bg-staticprimary dark:bg-staticprimary-900 text-xs relative">
      <img
        class="object-cover mix-blend-soft-light filter grayscale"
        src="@/assets/img/aside-image.webp"
        alt="Acceso a EdasNEO"
      />
      <div class="absolute bottom-4 left-0 w-full z-10 text-white">
        <div class="p-8 hidden">
          <h2 class="text-4xl font-bold mb-2">EdasNEO</h2>
          <h2 class="text-xl font-medium opacity-80">
            ZeroComa
          </h2>
        </div>
      </div>
    </aside>
    <div class="w-full flex flex-col min-h-full overflow-y-auto">
      <main class="main flex-grow">
        <slot name="main" />
        <h1 aria-label="Acceso a EdasNEO"></h1>
      </main>
      <footer class="flex-shrink-0 h-10 flex items-center justify-center dark:bg-staticdarkblue-900">
        <copy-legal />
      </footer>
    </div>
  </div>
</template>

<script>
import CopyLegal from '@/components/CopyLegal.vue'
export default {
  name: 'public-layout',
  props: {
    asideData: {
      type: Array,
      default: () => []
    }
  },
  components: {
    CopyLegal
  }
}
</script>
